import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";

import AddCartButtonProductDetail from "../../components/AddCartButtonProductDetail";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";
import activeDiscount from "../../helpers/activeDiscount";
import {
  setProduct,
  getProductBySlug,
  otherProducts,
} from "../../store/actions/product";
import { PUBLIC_URL } from "../../config";
import styles from "../../thema/style";
import { Link } from "react-router-dom";

class Product extends Component {
  state = {
    img: "",
    lightbox: false,
  };
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.containerLeftArrow = React.createRef();
    this.containerRightArrow = React.createRef();
    this.img = React.createRef();
  }

  handleClickOutside = (event) => {
    if (
      this.containerRef.current &&
      this.containerLeftArrow.current &&
      this.containerRightArrow.current
    ) {
      if (
        !this.containerRef.current.contains(event.target) &&
        !this.containerLeftArrow.current.contains(event.target) &&
        !this.containerRightArrow.current.contains(event.target)
      ) {
        this.setState({ lightbox: false });
      }
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.props.otherProducts();
    if (this.props.location.state && this.props.location.state.product) {
      this.props.setProduct(this.props.location.state.product, (img) => {
        this.setState({ img });
      });
    } else {
      this.props.getProductBySlug(this.props.match.params.slug, (img) => {
        this.setState({ img });
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.state) {
      if (prevProps.location.state) {
        if (this.props.location.state && this.props.location.state.product) {
          if (
            prevProps.location.state.product !==
            this.props.location.state.product
          ) {
            this.props.setProduct(this.props.location.state.product, (img) => {
              this.setState({ img }, () => {
                window.scrollTo(0, 180);
              });
            });
          }
        }
      }
    } else {
      if (this.props.location.state) {
        if (this.props.location.state && this.props.location.state.product) {
          this.props.setProduct(this.props.location.state.product, (img) => {
            this.setState({ img }, () => {
              window.scrollTo(0, 180);
            });
          });
        }
      }
    }
  }

  lightbox() {
    const { product } = this.props.product;
    return (
      <div
        style={{
          zIndex: 999999999999,
          position: "fixed",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.9)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
        }}
      >
        <div
          onClick={() => {
            this.setState({ lightbox: false });
          }}
          style={{
            cursor: "pointer",
            position: "fixed",
            top: 10,
            right: 20,
          }}
        >
          <FontAwesomeIcon icon={["fas", "times"]} size={"2x"} />
        </div>
        <div
          ref={this.containerLeftArrow}
          onClick={() => {
            const images = [product.image, ...product.images];
            const index = images.findIndex((img) => img === this.state.img);
            const nextIndex = index - 1 < 0 ? images.length - 1 : index - 1;
            this.setState({ img: images[nextIndex] });
          }}
          style={{ cursor: "pointer", position: "fixed", top: "50%", left: 20 }}
        >
          <FontAwesomeIcon icon={["fas", "chevron-left"]} size={"4x"} />
        </div>
        <div
          ref={this.containerRightArrow}
          onClick={() => {
            const images = [product.image, ...product.images];
            const index = images.findIndex((img) => img === this.state.img);
            const nextIndex = index + 1 >= images.length ? 0 : index + 1;
            this.setState({ img: images[nextIndex] });
          }}
          style={{
            cursor: "pointer",
            position: "fixed",
            top: "50%",
            right: 20,
          }}
        >
          <FontAwesomeIcon icon={["fas", "chevron-right"]} size={"4x"} />
        </div>
        <img
          ref={this.containerRef}
          src={PUBLIC_URL(this.state.img)}
          style={{
            position: "relative",
            maxWidth: "80%",
            maxHeight: "80%",
            zIndex: 9999999999999,
          }}
        />
      </div>
    );
  }

  render() {
    if (!this.props.product.product) {
      return <Loading text="Ürün Yükleniyor..." />;
    }
    const { product } = this.props.product;

    const discount = activeDiscount(product.categories);

    return (
      <React.Fragment>
        {this.state.lightbox && this.lightbox()}
        <PageTitle title={product.name} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"} style={{ marginTop: 10 }}>
                <div className={`row ${styles.productWrapper} `}>
                  <div className={"col-md-5"}>
                    <div className={"product-image-preview"}>
                      <img
                        onClick={() => {
                          this.setState({ lightbox: true });
                        }}
                        ref={this.img}
                        className={"img-thumbnail"}
                        style={{ width: "100%" }}
                        src={PUBLIC_URL(this.state.img)}
                      />
                    </div>
                    <div className={"product-images"}>
                      {[product.image, ...product.images].map((img, i) => (
                        <img
                          key={i}
                          onClick={() => {
                            this.setState({ img });
                          }}
                          className={"img-thumbnail"}
                          src={PUBLIC_URL(img)}
                        />
                      ))}
                    </div>
                  </div>
                  <div className={"col-md-7"}>
                    <h3>{product.name}</h3>
                    <div className={"product-stock"}>
                      <span>Ürün Stok Durumu:</span> {product.stock_status}
                    </div>

                    {discount ? (
                      <div className="product-price">
                        <span>Ürün Fiyatı:</span>
                        {product.sale_price ? (
                          <div className="old-price">₺{product.sale_price}</div>
                        ) : (
                          <div className="old-price">₺{product.price}</div>
                        )}
                      </div>
                    ) : (
                      <div className="product-price">
                        <span>Ürün Fiyatı:</span>
                        {product.sale_price ? (
                          <React.Fragment>
                            <div className="old-price">₺{product.price}</div>
                            <div className="special-price">
                              ₺{product.sale_price}
                            </div>
                          </React.Fragment>
                        ) : (
                          <div className="special-price">₺{product.price}</div>
                        )}
                      </div>
                    )}

                    {discount ? (
                      <div className="product-price">
                        <span>
                          Sepette{" "}
                          {discount.type === "percent"
                            ? `%${discount.discount} `
                            : `${parseFloat(discount.discount).toFixed(2)} TL `}
                          İndirim:
                        </span>
                        <div className="special-price">
                          ₺
                          {parseFloat(
                            product.sale_price
                              ? discount.type === "percent"
                                ? product.sale_price *
                                  (1 - discount.discount / 100)
                                : product.sale_price - discount.discount
                              : discount.type === "percent"
                              ? product.price * (1 - discount.discount / 100)
                              : product.price - discount.discount
                          ).toFixed(2)}
                        </div>
                      </div>
                    ) : null}

                    {product.stock > 0 ? (
                      <AddCartButtonProductDetail
                        product={product}
                        img={this.img}
                      />
                    ) : (
                      <p style={{ fontSize: 18, fontWeight: "bold" }}>
                        {product.stock_status}
                      </p>
                    )}
                    {/*  {product.online_shopping && (
                       <div>
                         <a
                           href={product.online_shopping}
                           target="_blank"
                           className={styles.onlineShopButton}
                         >
                           <img src={"/images/n11.png"} />
                           Online Alışveriş
                         </a>
                       </div>
                     )} */}
                    {product.online_shopping &&
                      product.online_shopping.map((online_shopping, i) => (
                        <div>
                          <a
                            href={online_shopping.url}
                            target="_blank"
                            className={
                              styles[`onlineShopButton${online_shopping.key}`]
                            }
                          >
                            <img src={`/images/${online_shopping.key}.png`} />
                            Online Alışveriş
                          </a>
                        </div>
                      ))}
                    {this.props.setting.setting.free_shipping > 0 && (
                      <div
                        style={{ marginTop: 50 }}
                        className={styles.freeShipping}
                      >
                        <div className={"free-shipping-wrapper"}>
                          <div>
                            <span>
                              {this.props.setting.setting.free_shipping} TL ve
                              Üzeri
                            </span>
                            <p>
                              Kargo
                              <br />
                              Bedava
                            </p>
                          </div>
                          <FontAwesomeIcon
                            size={"2x"}
                            color={"#f28b00"}
                            icon={["fas", "shipping-fast"]}
                            style={{
                              marginBottom: 12,
                              marginLeft: 5,
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <div className="product-category">
                      <span>Kategoriler:</span>
                      {product.categories.map((category, i, arr) => (
                        <React.Fragment>
                          <Link
                            key={i}
                            to={{
                              pathname: `/kategori/${category.slug}`,
                              state: { category: category },
                            }}
                          >
                            {category.title}
                          </Link>
                          {i < arr.length - 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                    </div>
                    <div className="social-bar">
                      <ul>
                        <li>
                          <a
                            className={"facebook"}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              // https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fispartatv.tv%2Fhaber-21%2Fcesur-kararlar.html&t=CESUR%20KARARLARIsparta%20TV
                              window.open(
                                `https://www.facebook.com/sharer/sharer.php?u=${window.location}&t=${product.name}`,
                                "share",
                                "menubar=no,status=no,resizable=yes,menubar=no,width=500,height=400"
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={["fab", "facebook"]} />
                          </a>
                        </li>
                        <li>
                          <a
                            className={"twitter"}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                `https://twitter.com/home?status=${window.location}`,
                                "share",
                                "menubar=no,status=no,resizable=yes,menubar=no,width=500,height=400"
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={["fab", "twitter"]} />
                          </a>
                        </li>

                        <li>
                          <a
                            className={"pinterest"}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                `https://pinterest.com/pin/create/button/?url=${
                                  window.location
                                }&media=${PUBLIC_URL(
                                  product.image
                                )}&description=${product.name}`,
                                "share",
                                "menubar=no,status=no,resizable=yes,menubar=no,width=500,height=400"
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={["fab", "pinterest"]} />
                          </a>
                        </li>

                        <li>
                          <a
                            className={"google-plus"}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                `https://plus.google.com/share?url=${window.location}`,
                                "share",
                                "menubar=no,status=no,resizable=yes,menubar=no,width=500,height=400"
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={["fab", "google-plus-g"]} />
                          </a>
                        </li>

                        <li>
                          <a
                            className={"email"}
                            href={`mailto:Gönderilecek Kişi?&subject=${product.name}&body=${window.location}`}
                          >
                            <FontAwesomeIcon
                              icon={["fas", "envelope-square"]}
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={"row"} style={{ marginTop: 10 }}>
                  <div className={"col-md-12"}>
                    <div className={styles.productDetailButton}>
                      Ürün Açıklaması
                    </div>
                    <div
                      className={styles.productDetail}
                      dangerouslySetInnerHTML={{ __html: product.content }}
                    />
                  </div>
                </div>
              </div>
              <div className={"col-md-3"}>
                <CartWidget />
                <CategoriesWidget />
              </div>
            </div>
            <div className={"row"} style={{ marginTop: 10, marginBottom: 40 }}>
              <div className={"col-md-12"}>
                <h3 style={{ fontSize: 25, marginBottom: 20 }}>
                  Diğer İlgi Çeken Ürünler
                </h3>
              </div>
              {this.props.product.otherFetching ? (
                <Loading text={"İlginizi çekebilecek ürünler yükleniyor.."} />
              ) : (
                this.props.product.otherProducts.map((product, i) => (
                  <ProductItem {...product} key={i} />
                ))
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting, category, product }) => {
  return { setting, category, product };
};

const mapDispatchToProps = {
  setProduct,
  getProductBySlug,
  otherProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);



// WEBPACK FOOTER //
// ./src/routers/Product/index.js